export default __webpack_public_path__ + "static/media/avatarA6.e0803832.png";